var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1539 4.85714C16.1539 4.19303 16.3905 3.54964 16.8232 3.0376C17.2559 2.52555 17.8576 2.17684 18.5249 2.05142C19.1922 1.92599 19.8833 2.03169 20.4795 2.35034C21.0756 2.66898 21.5396 3.18067 21.7916 3.79743C22.0436 4.41419 22.0678 5.09748 21.8602 5.72983C21.6526 6.36219 21.2261 6.90409 20.6539 7.26238C20.0818 7.62067 19.3999 7.77295 18.7253 7.69306C18.0508 7.61316 17.4257 7.30608 16.9578 6.82459L8.75277 11.2804C8.87813 11.7519 8.87813 12.2469 8.75277 12.7184L16.9578 17.1742C17.4481 16.6703 18.1096 16.3585 18.8183 16.2973C19.5271 16.2361 20.2343 16.4296 20.8075 16.8415C21.3807 17.2535 21.7804 17.8557 21.9319 18.5351C22.0833 19.2146 21.9759 19.9247 21.63 20.5323C21.284 21.1399 20.7231 21.6034 20.0526 21.8358C19.382 22.0681 18.6477 22.0535 17.9874 21.7946C17.3271 21.5356 16.786 21.0502 16.4657 20.4293C16.1454 19.8084 16.0678 19.0946 16.2475 18.4217L8.04248 13.9668C7.63993 14.3811 7.11955 14.6679 6.54855 14.7901C5.97756 14.9124 5.38218 14.8645 4.8393 14.6527C4.29643 14.4409 3.831 14.0748 3.50313 13.6019C3.17525 13.1289 3 12.5707 3 11.9994C3 11.4281 3.17525 10.8699 3.50313 10.3969C3.831 9.92395 4.29643 9.55792 4.8393 9.3461C5.38218 9.13429 5.97756 9.08642 6.54855 9.20867C7.11955 9.33093 7.63993 9.6177 8.04248 10.0319L16.2475 5.57613C16.1852 5.34132 16.1537 5.09971 16.1539 4.85714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHub);
export default __webpack_public_path__ + "static/media/hub.ec72bee649ff4b454f6b0b934a3434d5.svg";
export { ForwardRef as ReactComponent };